import { useState } from 'react';

export const useListingForm = (initialData = {}) => {
  const [formData, setFormData] = useState({
    title: '',
    location: '',
    startDate: '',
    endDate: '',
    capacity: 1,
    basePrice: 0,
    price: 0, // Keep for backward compatibility
    dailyPrice: 0,
    pricingModel: 'base', // 'base' or 'daily'
    selectedDates: [], // Selected dates for daily pricing calculation
    currency: 'USD',
    description: '',
    highlights: '',
    whatIncluded: '',
    whatToBring: '',
    photos: [],
    amenities: [],
    bookingWindow: 30,
    minStay: 1,
    maxStay: '',
    instantBooking: false,
    blockedDates: [],
    packages: [],
    reviews: [],
    instructorName: '',
    instructorBio: '',
    instructorEmail: '',
    instructorWebsite: '',
    instructorInstagram: '',
    ...initialData,
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const toggleAmenity = (amenityId) => {
    setFormData((prev) => ({
      ...prev,
      amenities: prev.amenities.includes(amenityId)
        ? prev.amenities.filter((id) => id !== amenityId)
        : [...prev.amenities, amenityId],
    }));
  };

  const validateStep = (step) => {
    switch (step) {
      case 1: // Basic Info
        if (!formData.title || !formData.location || !formData.startDate || !formData.endDate || !formData.capacity) {
          return { valid: false, error: 'Please fill in all required fields' };
        }
        if (new Date(formData.startDate) >= new Date(formData.endDate)) {
          return { valid: false, error: 'End date must be after start date' };
        }
        break;
      case 2: // Description
        if (!formData.description || !formData.highlights) {
          return { valid: false, error: 'Please provide description and highlights' };
        }
        break;
      case 3: // Photos
        // Validation handled by parent (needs photoFiles/existingPhotos)
        break;
      case 4: // Amenities
        // No required validation
        break;
      case 5: // Pricing
        if (formData.pricingModel === 'daily') {
          if (!formData.dailyPrice || parseFloat(formData.dailyPrice) <= 0) {
            return { valid: false, error: 'Please set a daily price' };
          }
        } else {
          if (!formData.basePrice && !formData.price) {
            return { valid: false, error: 'Please set a base price' };
          }
        }
        break;
      case 6: // Availability
        if (!formData.bookingWindow || !formData.minStay) {
          return { valid: false, error: 'Please set booking window and minimum stay' };
        }
        break;
      case 7: // Packages
        // Packages are optional, but if added, validate them
        if (formData.packages && formData.packages.length > 0) {
          for (const pkg of formData.packages) {
            if (!pkg.name || pkg.name.length < 50 || pkg.name.length > 100) {
              return { valid: false, error: 'Package name must be between 50-100 characters' };
            }
            if (!pkg.description || pkg.description.split(/\s+/).length < 300) {
              return { valid: false, error: 'Package description should be at least 300 words' };
            }
            if (!pkg.minGuests || !pkg.maxGuests || pkg.minGuests > pkg.maxGuests) {
              return { valid: false, error: 'Invalid guest limits for package' };
            }
          }
        }
        break;
      case 8: // Instructor Info
        // Optional, no validation needed
        break;
      default:
        break;
    }
    return { valid: true };
  };

  return {
    formData,
    setFormData: (data) => {
      if (typeof data === 'function') {
        setFormData(data);
      } else {
        setFormData((prev) => ({ ...prev, ...data }));
      }
    },
    handleInputChange,
    toggleAmenity,
    validateStep,
  };
};

